export function defeatCache(url) {
  const delim = url.includes('?') ? '&' : '?';
  return `${url}${delim}cwt=${Date.now()}`;
}

export function sendPSTracking(url, sent, resend = false) {
  if (!url || (!resend && sent.has(url))) {
    return false;
  }

  const img = new Image();
  img.src = defeatCache(url);
  sent.add(url);
  return true;
}

export function sendFPTITracking(api, eventCode, fptiProps, sent, resend = false) {
  if (!api || !fptiProps || !Object.keys(fptiProps).length) {
    return false;
  }
  const key = JSON.stringify({ ...fptiProps, e: eventCode });
  if (!resend && sent.has(key)) {
    return false;
  }
  if (!fptiProps.event_name) {
    console.error('FPTI data is missing event_name', fptiProps);
  }
  if (eventCode === 'im') {
    // NOTE: using 2nd argument will prevent API from saving tags
    // it does not need nested data key
    api.recordImpression(null, fptiProps);
    sent.add(key);
    return true;
  }
  if (eventCode === 'av') {
    api.record({
      data: {
        ...fptiProps,
        e: 'av',
      },
    });
    sent.add(key);
    return true;
  }
  if (eventCode === 'cl') {
    api.recordClick({
      data: fptiProps,
    });
    sent.add(key);
    return true;
  }
  return false;
}

export function isCenterWithin(elemBox, viewportBox) {
  const centerX = elemBox.x + elemBox.width / 2;
  const centerY = elemBox.y + elemBox.height / 2;
  return (
    centerX >= viewportBox.x &&
    centerX <= viewportBox.right &&
    centerY >= viewportBox.y &&
    centerY <= viewportBox.bottom
  );
}

export function parseFPTI(str) {
  try {
    const result = JSON.parse(str);
    if (Array.isArray(result)) {
      return result[0];
    }
    return result;
  } catch (e) {
    console.error(new Error('Tracking tried to parse fpti details but failed', { cause: e }));
    return {};
  }
}
